import {Link} from "react-router-dom";
import dataHome from "../data/index.json";
import "./Navbar.scss";

export type TProps = {
  onMenuClick: () => void,
}

export default function Navbar(props: TProps) {
  return (
    <div className="c-navbar">
      <div className="c-navbar__left">
        <Link to="/" className="c-navbar__logo">{dataHome.title}</Link>
      </div>
      <div className="c-navbar__right">
        <div className="c-navbar__menu" onClick={props.onMenuClick}>
          <img src="/images/icon-menu.svg" alt="Menu toggle" />
        </div>
      </div>
    </div>
  );
}
